import { render, staticRenderFns } from "./chatDirectCreateDialog.vue?vue&type=template&id=034c7cad&scoped=true"
import script from "./chatDirectCreateDialog.vue?vue&type=script&lang=js"
export * from "./chatDirectCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./chatDirectCreateDialog.vue?vue&type=style&index=0&id=034c7cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c7cad",
  null
  
)

export default component.exports